import { Scrollbars } from "react-custom-scrollbars-2";
import { useLocation } from "react-router";
import { AppHeader } from "./Header";
import { AppFooter } from "./Footer";
import { useEffect, useRef, useState } from "react";
import { AppContext } from "./context/AppContext";
import { useQuery } from "@tanstack/react-query";
import {
  fetchApi,
  createQueryKey,
  longCacheOptions,
  shortCacheOptions,
} from "./utils/apiUtils";
import { playersAdapter } from "./utils/fftt/playersAdapter";
import { AllRoutes } from "./AllRoutes";
import { getTitleTagPerPage } from "./utils/gitTitleTagPerPage";
import CookieConsent, { getCookieConsentValue } from "react-cookie-consent";
import { trackPageView } from "./utils/sendTracking";

function App() {
  const [hasScrolled, setHasScrolled] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [selectedCategory, updateSelectedCategory] = useState(0);
  const [search, updateSearch] = useState("");

  let location = useLocation();

  useEffect(() => {
    if (
      getCookieConsentValue("consentCookie") &&
      getCookieConsentValue("consentCookie") !== false
    ) {
      initTracking();
    }
  }, []);

  const initTracking = () => {
    window._paq.push(["setConsentGiven"]);
    window._paq.push(["enableLinkTracking"]);

    trackPageView();
  };

  useEffect(() => {
    document.title = getTitleTagPerPage(location.pathname);
    trackPageView();

    scrollbarRef.current.view.scroll({
      top: 0,
    });
  }, [location]);

  const scrollbarRef = useRef();

  const { data: categories, isFetched: categoriesFetched } = useQuery({
    queryKey: createQueryKey("/wp-json/wp/v2/categories"),
    queryFn: () => fetchApi("/wp-json/wp/v2/categories"),
    ...longCacheOptions,
  });

  const { data: players, isFetched: playersFetched } = useQuery({
    queryKey: createQueryKey("/wp-json/playersFFTT/v1/all/1"),
    queryFn: async () => {
      const data = await fetchApi("/wp-json/playersFFTT/v1/all/1");
      return playersAdapter(data);
    },
    ...shortCacheOptions,
  });

  const updateScrollPosition = () => {
    const newPosition = scrollbarRef.current.getScrollTop();
    setScrollPosition(newPosition);
    if (newPosition > 80 && !hasScrolled) {
      setHasScrolled(true);
    } else if (newPosition < 80 && hasScrolled) {
      setHasScrolled(false);
    }
  };

  return (
    <AppContext.Provider
      value={{
        search,
        selectedCategory,
        updateSearch,
        updateSelectedCategory,
        categories: categories,
        categoriesFetched: categoriesFetched,
        scrollbarRef,
        hasScrolled,
        scrollPosition,
        // Pages content
        players,
        playersFetched: playersFetched,
      }}
    >
      <CookieConsent
        location="bottom"
        buttonText="J'accepte"
        cookieName="consentCookie"
        style={{ background: "#0f1333" }}
        declineButtonText="Je refuse"
        declineCookieValue={false}
        enableDeclineButton={true}
        buttonStyle={{
          color: "#fff",
          backgroundColor: "#ee3962",
        }}
        declineButtonStyle={{
          color: "#fff",
          backgroundColor: "transparent",
        }}
        expires={90}
        onAccept={initTracking}
      >
        Ce site récupère des données anonymisées dans le but d'améliorer
        l'expérience utilisateur.{" "}
      </CookieConsent>
      <Scrollbars
        ref={scrollbarRef}
        className="scrollbar"
        autoHide
        onScroll={updateScrollPosition}
        autoHideTimeout={2000}
        autoHideDuration={800}
      >
        <div className="content-wrapper">
          <AppHeader />
          <section id="content">
            <AllRoutes />
          </section>
          <footer>
            <AppFooter />
          </footer>
        </div>
      </Scrollbars>
    </AppContext.Provider>
  );
}

export default App;
